module.exports = "https://cdn.redage.net/src/views/games/other/images/maps/map_1.png";